export default __webpack_public_path__ + "static/media/arrow_left_bold.f44b933e.svg";